/*
 * Fork Instinct: no pre-selected size.
 * Apparel is made to order, so the shopper must pick a size on purpose. On product pages and in the
 * quick-add dialog the Size option starts empty (colour stays pre-selected), the add buttons read
 * "Select a size", and pressing them points at the size row instead of adding the first size.
 * A ?variant= link on the product page counts as a deliberate choice. Without JS the theme behaves as before.
 */
(function () {
  const SIZE = /^size$|^sizes$|size$/i;
  const PROMPT = 'Select a size';
  const urlHasVariant = new URLSearchParams(window.location.search).has('variant');

  const style = document.createElement('style');
  style.textContent = `
[data-fi-need-size] [ref="addToCartButton"] .add-to-cart-text__content > span:first-child,
[data-fi-need-size] .sticky-add-to-cart__button .add-to-cart-text__content > span:first-child,
[data-fi-need-size] [ref="addToCartButton"] .svg-wrapper,
[data-fi-need-size] .sticky-add-to-cart__button .svg-wrapper{display:none}
[data-fi-need-size] [ref="addToCartButton"] .add-to-cart-text__content::before,
[data-fi-need-size] .sticky-add-to-cart__button .add-to-cart-text__content::before{content:"${PROMPT}"}
[data-fi-need-size] .sticky-add-to-cart__variant{font-size:0}
[data-fi-need-size] .sticky-add-to-cart__variant::after{content:"${PROMPT}";font-size:.8125rem}
[data-fi-need-size] shopify-accelerated-checkout,[data-fi-need-size] .shopify-payment-button{opacity:.45;pointer-events:none}
[data-fi-need-size] product-form-component [ref="addToCartButton"]{font-size:0}
[data-fi-need-size] product-form-component [ref="addToCartButton"] .add-to-cart-icon{display:none}
[data-fi-need-size] product-form-component [ref="addToCartButton"]::after{content:"${PROMPT}";font-size:1rem}
@media screen and (max-width:749px){[data-fi-need-size] .sticky-add-to-cart__bar .add-to-cart-text__content{display:initial}[data-fi-need-size] .sticky-add-to-cart__bar .sticky-add-to-cart__button{width:auto;padding-inline:16px}}
variant-picker fieldset:not(:has(input:checked)) .variant-option__button-label__pill{visibility:hidden}
fieldset.fi-size-error{outline:2px solid #b3261e;outline-offset:6px;border-radius:4px}
.fi-size-msg{display:block;flex-basis:100%;width:100%;grid-column:1 / -1;margin-top:8px;color:#b3261e;font-size:.8125rem;font-weight:600}
`;
  document.head.appendChild(style);

  /* Screen readers: while no size is chosen, the add buttons (product form, sticky bar, quick add)
     carry aria-label "Select a size", matching the label sighted shoppers see. */
  const BUTTONS = '[ref="addToCartButton"], .sticky-add-to-cart__button';
  function setA11y(scope, need) {
    for (const b of scope.querySelectorAll(BUTTONS)) {
      if (b.closest('product-card')) continue;
      if (need) {
        if (b.getAttribute('aria-label') !== PROMPT) b.setAttribute('aria-label', PROMPT);
        b.dataset.fiSizeLabel = '';
      } else if (b.hasAttribute('data-fi-size-label')) {
        b.removeAttribute('aria-label');
        b.removeAttribute('data-fi-size-label');
      }
    }
  }

  /** The element that holds one product's picker, buy buttons and sticky bar. */
  function scopeOf(picker) {
    return picker.closest('quick-add-dialog, dialog, .shopify-section') || picker.parentElement;
  }

  function sizeInputs(picker) {
    return Array.from(picker.querySelectorAll('fieldset input[type="radio"][data-option-name]')).filter((i) =>
      SIZE.test((i.dataset.optionName || '').trim())
    );
  }

  function guarded(picker) {
    if (picker.closest('product-card')) return false;
    return sizeInputs(picker).length > 1;
  }

  function enforce(picker) {
    if (!guarded(picker)) return;
    const scope = scopeOf(picker);
    // The quick-add dialog reuses its picker for the next product: start that product fresh.
    if (picker.fiProduct !== picker.dataset.productId) {
      picker.fiProduct = picker.dataset.productId;
      picker.fiSizeChosen = undefined;
    }
    if (picker.fiSizeChosen === undefined) {
      const onPage = picker.dataset.templateProductMatch === 'true' && !picker.closest('quick-add-dialog, dialog');
      picker.fiSizeChosen = onPage && urlHasVariant;
    }
    if (picker.fiSizeChosen) {
      scope.removeAttribute('data-fi-need-size');
      setA11y(scope, false);
      return;
    }
    for (const input of sizeInputs(picker)) {
      if (input.checked) input.checked = false;
      if (input.dataset.currentChecked === 'true') input.dataset.currentChecked = 'false';
    }
    scope.setAttribute('data-fi-need-size', '');
    setA11y(scope, true);
    waiting.add(picker);
  }

  /* Re-renders (colour change, quick-add morph) can set .checked without touching attributes, so
     pickers still waiting for a size are re-checked on a light timer as well as by the observer. */
  const waiting = new Set();
  setInterval(() => {
    for (const picker of waiting) {
      if (!picker.isConnected || picker.fiSizeChosen) waiting.delete(picker);
      else if (sizeInputs(picker).some((i) => i.checked)) enforce(picker);
      else setA11y(scopeOf(picker), true);
    }
  }, 300);

  function scan(root) {
    for (const picker of root.querySelectorAll('variant-picker')) {
      enforce(picker);
      if (picker.fiSizeWatch) continue;
      let queued = false;
      picker.fiSizeWatch = new MutationObserver(() => {
        if (queued) return;
        queued = true;
        requestAnimationFrame(() => {
          queued = false;
          enforce(picker);
        });
      });
      picker.fiSizeWatch.observe(picker, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeFilter: ['checked', 'data-current-checked'],
      });
    }
  }

  function showPrompt(scope) {
    const picker = Array.from(scope.querySelectorAll('variant-picker')).find((p) => guarded(p) && !p.fiSizeChosen);
    if (!picker) return;
    const first = sizeInputs(picker)[0];
    const fieldset = first && first.closest('fieldset');
    if (!fieldset) return;
    fieldset.classList.add('fi-size-error');
    if (!fieldset.querySelector('.fi-size-msg')) {
      const msg = document.createElement('span');
      msg.className = 'fi-size-msg';
      msg.setAttribute('role', 'alert');
      msg.textContent = 'Please select a size first.';
      fieldset.appendChild(msg);
    }
    fieldset.scrollIntoView({ behavior: 'smooth', block: 'center' });
    const target = sizeInputs(picker).find((i) => i.getAttribute('aria-disabled') !== 'true') || first;
    try {
      target.focus({ preventScroll: true });
    } catch (e) {
      /* ignore */
    }
  }

  function blockIfNeeded(event, el) {
    const scope = el.closest('[data-fi-need-size]');
    if (!scope) return false;
    event.preventDefault();
    event.stopImmediatePropagation();
    showPrompt(scope);
    return true;
  }

  window.addEventListener(
    'click',
    (event) => {
      const el = event.target instanceof Element ? event.target : null;
      if (!el) return;
      const button = el.closest('[ref="addToCartButton"], .sticky-add-to-cart__button, button[name="add"]');
      if (!button || button.closest('product-card')) return;
      if (button.dataset.puppet === 'true') return;
      blockIfNeeded(event, button);
    },
    true
  );

  window.addEventListener(
    'submit',
    (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement) || form.closest('product-card')) return;
      if (form.getAttribute('data-type') !== 'add-to-cart-form') return;
      blockIfNeeded(event, form);
    },
    true
  );

  window.addEventListener(
    'change',
    (event) => {
      const input = event.target;
      if (!(input instanceof HTMLInputElement)) return;
      const picker = input.closest('variant-picker');
      if (!picker) return;
      if (!SIZE.test((input.dataset.optionName || '').trim())) {
        // Another option (colour) changed: the re-rendered picker comes back with a size ticked; clear it again.
        if (!picker.fiSizeChosen && guarded(picker)) {
          for (const t of [60, 250, 600, 1000, 1600, 2500, 4000]) setTimeout(() => enforce(picker), t);
        }
        return;
      }
      picker.fiSizeChosen = true;
      const scope = scopeOf(picker);
      scope.removeAttribute('data-fi-need-size');
      setA11y(scope, false);
      for (const fs of scope.querySelectorAll('fieldset.fi-size-error')) {
        fs.classList.remove('fi-size-error');
        fs.querySelector('.fi-size-msg')?.remove();
      }
    },
    true
  );

  function start() {
    scan(document);
    new MutationObserver((records) => {
      for (const r of records) {
        for (const node of r.addedNodes) {
          if (!(node instanceof Element)) continue;
          if (node.matches('variant-picker') || node.querySelector('variant-picker')) {
            scan(node.matches('variant-picker') ? node.parentElement || document : node);
          }
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
